module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c(_vm.tagType, {
    tag: "component",
    staticClass: "MediaGridItemImage",
    attrs: {
      "to": _vm.data.route || false,
      "href": _vm.data.link || false
    }
  }, [_c('image-component', _vm._b({
    attrs: {
      "zoom": !!_vm.data.route || !!_vm.data.link
    }
  }, 'image-component', _vm.data.image, false))], 1), _vm._v(" "), (_vm.data.title) ? _c('media-grid-item-title', {
    attrs: {
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.description) ? _c('media-grid-item-description', {
    attrs: {
      "data": _vm.data
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8845f646"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaGridItemImage.vue
// module id = 787
// module chunks = 1474